import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Growth", href: "#growth" },
  { label: "Outcomes", href: "#outcomes" },
  { label: "Academy", href: "#academy" },
  { label: "Founder", href: "#founder" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-sebyx-bg/85 backdrop-blur-md border-b border-sebyx-border"
          : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-24 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span className="block w-2 h-2 bg-sebyx-accent group-hover:rotate-45 transition-transform" />
          <span className="font-display text-xl font-semibold tracking-tight text-sebyx-text">
            Sebyx
          </span>
          <span className="font-mono text-[10px] text-sebyx-muted hidden sm:block">
            / Revenue Architecture
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-sebyx-muted hover:text-sebyx-accent transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#growth-form"
          data-testid="nav-cta-audit"
          className="hidden md:inline-flex items-center gap-2 px-4 py-2 bg-sebyx-accent text-sebyx-bg font-semibold text-sm hover:bg-[#3FA097] transition-colors"
        >
          Book a Growth Conversation
          <span aria-hidden>→</span>
        </a>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((s) => !s)}
          className="md:hidden text-sebyx-text p-2"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-sebyx-border bg-sebyx-bg"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-mono text-xs uppercase tracking-[0.2em] text-sebyx-muted hover:text-sebyx-accent"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#growth-form"
              onClick={() => setOpen(false)}
              className="inline-flex w-fit items-center gap-2 px-4 py-2 bg-sebyx-accent text-sebyx-bg font-semibold text-sm"
            >
              Book a Growth Conversation →
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
